import { createI18n, type I18n } from 'vue-i18n';
import { registerLocale } from 'i18n-iso-countries';
import countriesDE from 'i18n-iso-countries/langs/de.json';
import countriesEN from 'i18n-iso-countries/langs/en.json';
import countriesES from 'i18n-iso-countries/langs/es.json';
import countriesFR from 'i18n-iso-countries/langs/fr.json';
import countriesNL from 'i18n-iso-countries/langs/nl.json';
import messages from '@intlify/unplugin-vue-i18n/messages';
import storybookMessages from '@cirqll/storybook/messages';
import type { UserModule } from '~/types';

registerLocale(countriesDE);
registerLocale(countriesEN);
registerLocale(countriesES);
registerLocale(countriesFR);
registerLocale(countriesNL);

export let i18n: I18n<
    Record<string, unknown>,
    Record<string, Record<string, Intl.DateTimeFormatOptions>>,
    Record<string, unknown>,
    string,
    false>;

const datetimeFormat: Record<string, Intl.DateTimeFormatOptions> = {
    narrowDay: { weekday: 'narrow' },
    day: { weekday: 'long' },
    time: {
        hour: '2-digit',
        minute: '2-digit',
    },
    month: {
        month: 'long',
        year: 'numeric',
    },
    short: {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    },
    numeric: {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    },
    shortDay: {
        month: 'long',
        day: 'numeric',
        weekday: 'long',
    },
    dateOnly: {
        month: 'long',
        day: 'numeric',
    },
    long: {
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        year: 'numeric',
    },
    shortTime: {
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: '2-digit',
        minute: '2-digit',
    },
    numericDateTime: {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    },
};

export const install: UserModule = ({ app }) => {
    const locale = localStorage.getItem('language') ?? 'nl';

    i18n = createI18n({
        legacy: false,
        locale,
        messages,
        datetimeFormats: Object.fromEntries(Object.keys(messages as any).map((key) => [key, datetimeFormat])),
    });

    for (const [locale, messages] of Object.entries(storybookMessages)) {
        i18n.global.mergeLocaleMessage(locale, messages);
    }

    document.documentElement.lang = locale;
    watch(i18n.global.locale, (newLocale) => {
        document.documentElement.lang = newLocale;
    });

    app.use(i18n);
};
